import React from 'react';
import { buildKey, escapeImageUrl } from '@yme/utils/common';
const buildSourceAttrs = ({ src, rule, media, type, }) => ({
    srcSet: `${escapeImageUrl(src)} ${rule || ''}`,
    ...(media
        ? {
            media,
        }
        : {}),
    ...(type
        ? {
            type,
        }
        : {}),
});
export function getImageSources(srcSet = []) {
    return srcSet.map(({ src, media = '', rule = '', type = '' }, i) => {
        const sourceAttrs = buildSourceAttrs({
            src,
            media,
            rule,
            type,
        });
        return (React.createElement("source", { ...sourceAttrs, key: buildKey(src, i) }));
    });
}
